import React, { useEffect, useState } from 'react';
import ListingTable from '@components/table/ListingTable';
import { facultativesHeaders } from './content';
import ToastErrorMessage from '@components/toast/ToastErrorMessage';
import { getError } from '@utils/graph-utils';
import { toast } from 'react-toastify';
import { IListingData } from '@models/listing';
import { mapToListingData } from './utils';
import { IAbstractRecord } from '@models';

interface IFacultativesWidget {
  data: IAbstractRecord;
  loading: boolean;
}

const FacultativesWidget: React.FC<IFacultativesWidget> = ({
  data,
  loading,
}) => {
  const [tableData, setTableData] = useState<IListingData>({
    pagedItems: {},
    pageNumber: 1,
    pageSize: 5,
    totalCount: 0,
  });

  const initialize = () => {
    try {
      if (data) {
        const mappedData = mapToListingData(
          data.Accounting.queries.GetFacOfPoliciesOfReinsurer
        );
        setTableData({
          pagedItems: mappedData,
          pageNumber: 1,
          pageSize: 5,
          totalCount: Object.keys(mappedData).length,
        });
      }
    } catch (error) {
      toast.error(<ToastErrorMessage>{getError(error)}</ToastErrorMessage>);
    }
  };

  useEffect(() => {
    initialize();
  }, [data]);

  return (
    <ListingTable
      name={'facultatives'}
      inlineTitle="Facultatives"
      headers={facultativesHeaders}
      data={tableData}
      loader={loading}
      actions={[]}
      disableSelection
      inline
    />
  );
};

export default FacultativesWidget;
